// client/src/context/CategoryContext.js
// Replaces the old hardcoded CATEGORY_TREE constant - each store now has its
// own category taxonomy (a dive shop's categories look nothing like an RC
// shop's), fetched from the store-scoped GET /api/categories.
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../utils/media';

export const CategoryContext = createContext({
  categories: [], // [{ id, name, icon_key, children: [{ id, name }] }]
  categoryNames: [], // top-level names only, for quick iteration
  subcategoriesFor: () => [],
  loaded: false,
  refreshCategories: () => {},
});

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refreshCategories = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Failed to fetch categories', error);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refreshCategories(); }, [refreshCategories]);

  const categoryNames = categories.map((c) => c.name);
  const subcategoriesFor = (categoryName) => {
    const match = categories.find((c) => c.name === categoryName);
    return match ? match.children.map((sc) => sc.name) : [];
  };
  const iconKeyFor = (categoryName) => categories.find((c) => c.name === categoryName)?.icon_key || 'other';

  return (
    <CategoryContext.Provider value={{ categories, categoryNames, subcategoriesFor, iconKeyFor, loaded, refreshCategories }}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategories = () => useContext(CategoryContext);
